export default __webpack_public_path__ + "static/media/ic_person.88921491.svg";